module.exports = __webpack_public_path__ + "img/79.b5f676a9.jpg";